import {
    FETCH_SCHEDULE_TECHNICIANS,
    FETCH_SCHEDULED_APPOINTMENTS,
    FETCH_UNSCHEDULED_APPOINTMENTS
} from '../actions/actionTypes';

const initialState = {
    scheduledAppointments:   [],
    technicians:             [],
    unscheduledAppointments: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SCHEDULE_TECHNICIANS:
            return {
                ...state,
                technicians: [...action.payload]
            };
        case FETCH_SCHEDULED_APPOINTMENTS:
            return {
                ...state,
                scheduledAppointments: [...action.payload]
            };
        case FETCH_UNSCHEDULED_APPOINTMENTS:
            return {
                ...state,
                unscheduledAppointments: [...action.payload]
            };
        default:
            return state;
    }
};
